import React, { useState } from 'react';
import { BottomNav } from './components/BottomNav';
import { TopUpModal } from './components/TopUpModal';
import { HomeScreen } from './pages/HomeScreen';
import { CardScreen } from './pages/CardScreen';
import { TravelScreen } from './pages/TravelScreen';
import { ProfileScreen } from './pages/ProfileScreen';
import { FlightSearchScreen } from './pages/FlightSearchScreen';
import { FlightResultsScreen } from './pages/FlightResultsScreen';
import { FlightCheckoutScreen } from './pages/FlightCheckoutScreen';
import { FlightConfirmationScreen } from './pages/FlightConfirmationScreen';
import { ESIMScreen } from './pages/ESIMScreen';
import { ESIMConfirmationScreen } from './pages/ESIMConfirmationScreen';
export function App() {
  const [activeTab, setActiveTab] = useState<'home' | 'card' | 'travel' | 'profile'>('home');
  const [activeScreen, setActiveScreen] = useState<string | null>(null);
  const [isTopUpOpen, setIsTopUpOpen] = useState(false);
  // Navigation Handlers
  const handleNavigate = (screen: string) => {
    setActiveScreen(screen);
  };
  const handleBack = () => {
    setActiveScreen(null);
  };
  const handleHome = () => {
    setActiveScreen(null);
    setActiveTab('home');
  };
  // Render Content based on state
  const renderContent = () => {
    // Full screen overlays (Travel flows)
    if (activeScreen === 'flight-search') {
      return <FlightSearchScreen onBack={handleBack} onSearch={() => handleNavigate('flight-results')} data-id="element-0" />;
    }
    if (activeScreen === 'flight-results') {
      return <FlightResultsScreen onBack={() => handleNavigate('flight-search')} onSelect={() => handleNavigate('flight-checkout')} data-id="element-1" />;
    }
    if (activeScreen === 'flight-checkout') {
      return <FlightCheckoutScreen onBack={() => handleNavigate('flight-results')} onConfirm={() => handleNavigate('flight-confirmation')} data-id="element-2" />;
    }
    if (activeScreen === 'flight-confirmation') {
      return <FlightConfirmationScreen onHome={handleHome} data-id="element-3" />;
    }
    if (activeScreen === 'esim') {
      return <ESIMScreen onBack={handleBack} onPurchase={() => handleNavigate('esim-confirmation')} data-id="element-4" />;
    }
    if (activeScreen === 'esim-confirmation') {
      return <ESIMConfirmationScreen onHome={handleHome} data-id="element-5" />;
    }
    // Main Tabs
    switch (activeTab) {
      case 'home':
        return <HomeScreen onNavigate={handleNavigate} onTopUp={() => setIsTopUpOpen(true)} data-id="element-6" />;
      case 'card':
        return <CardScreen data-id="element-7" />;
      case 'travel':
        return <TravelScreen onNavigate={handleNavigate} data-id="element-8" />;
      case 'profile':
        return <ProfileScreen data-id="element-9" />;
      default:
        return <HomeScreen onNavigate={handleNavigate} onTopUp={() => setIsTopUpOpen(true)} data-id="element-10" />;
    }
  };
  return <div className="min-h-screen bg-gray-100 flex justify-center" data-id="element-11">
      {/* Mobile Container */}
      <div className="w-full max-w-md bg-white min-h-screen shadow-2xl relative overflow-hidden" data-id="element-12">
        {renderContent()}

        {/* Bottom Nav - Only show on main tabs */}
        {!activeScreen && <BottomNav activeTab={activeTab} onTabChange={setActiveTab} data-id="element-13" />}

        {/* Modals */}
        <TopUpModal isOpen={isTopUpOpen} onClose={() => setIsTopUpOpen(false)} data-id="element-14" />
      </div>
    </div>;
}